import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount) => {
        // Retry up to 2 times
        return failureCount < 2;
      },
      staleTime: 60 * 1000, // 1 minute in milliseconds
    },
    mutations: {
      retry: 2,
      // Need this so that if the user goes offline during useQuery or useMutation
      // this prevents the application from pausing and hanging until they come back online.
      // Instead of pausing, the query errors like normal and we can catch it in the onError callback.
      networkMode: 'always',
    },
  },
});
